const { View } = require('./core');

function isLeftButtonClick(e) {
  return e.button === 0;
}

/**
 * Base class for view that filter content for feed.
 */
class Filter extends View {
  constructor(...args) {
    super(...args);
    this.events.bind('mousedown [data-mode="reset"]', 'reset');
    this.events.bind('mousedown [data-mode="radio"]', 'toggle');
    this.events.bind('mousedown [data-mode="radioOneOnly"]', 'enable');
    this.events.bind('mousedown [data-mode="checkbox"]', 'toggle');
    this.events.bind('mousedown [data-mode="checkboxOneOnly"]', 'toggleOne');
    this.events.bind('click [data-mode]', (e) => e.preventDefault());
  }

  /**
   * Make a field of model empty
   * @param  {Event} e
   * @return {void}
   */
  reset(e) {
    if (isLeftButtonClick(e)) {
      this.emitFor('reset', e);
    }
  }

  /**
   * Enable a single value of model's field
   * @param  {Event} e
   * @return {void}
   */
  enable(e) {
    if (isLeftButtonClick(e)) {
      this.emitFor('enable', e);
    }
  }

  /**
   * Toggle state of a value of model's field
   * @param  {Event} e
   * @return {void}
   */
  toggle(e) {
    if (isLeftButtonClick(e)) {
      this.emitFor('toggle', e);
    }
  }

  /**
   * Toggle only one state of a value of model's field
   * @param  {Event} e
   * @return {void}
   */
  toggleOne(e) {
    if (isLeftButtonClick(e)) {
      this.emitFor('toggleOne', e);
    }
  }

  emitFor(action, e) {
    const target = e.delegateTarget;
    const key = target.getAttribute('data-key');
    const value = target.getAttribute('data-value');
    const keyInUrlPath = target.getAttribute('data-in-url');
    const keyGroup = target.getAttribute('data-key_group');

    if (action == 'toggle') {
      this.emit(action, key, value, keyGroup, keyInUrlPath);
    } else {
      this.emit(action, key, value, keyInUrlPath);
    }

    e.preventDefault();
  }

  render() {
    // no-op
  }
}

module.exports = {
  Filter,
};
